'use client';

import { useTranslations } from 'next-intl';

export function DesktopOnlyNotice() {
  const t = useTranslations('videoEditor.desktopOnly');

  return (
    <div className="flex h-full min-h-[480px] items-center justify-center bg-black px-6 text-white">
      <div className="flex max-w-[360px] flex-col items-center text-center">
        <div className="mb-5 flex size-14 items-center justify-center rounded-2xl border border-system-white12 bg-system-white08">
          <svg className="size-7 text-system-white80" viewBox="0 0 28 28" fill="none" aria-hidden="true">
            <rect x="4" y="6" width="20" height="14" rx="2" stroke="currentColor" strokeWidth="1.8" />
            <path d="M10 24h8M14 20v4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
          </svg>
        </div>
        <h1 className="font-semibold text-xl">{t('title')}</h1>
        <p className="mt-3 text-sm text-system-white64 leading-6">{t('description')}</p>
      </div>
    </div>
  );
}
